<template>
    <div class="animated fadeIn">
  
      <b-card class="card-accent-info">

        <div slot="header">
              Contas
              <div class="card-header-actions">
                
                <b-link href="#" class="card-header-action btn-help">
                  <i class="icon-question" @click="openHelp('/?page=finance/accounts')"></i>
                </b-link>
                
                <!--
                <b-link href="#" class="card-header-action btn-helpvie">
                  <i class="icon-film"></i>
                </b-link>
                -->
              </div>
        </div>

        <b-card-body>
 
          <b-row>

            <b-col cols="auto">
              <b-form-group >
                  <label for="perPage">Empresa</label>
                  <b-form-select v-model="filters.companyId" id="filterCompany"
                    :plain="true"
                    :options="this.companyDDL"
                    @change="refreshByCompany(filters.companyId)"
                    >
                  </b-form-select>
                </b-form-group>
            </b-col>

            <!--
            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Tipo de Conta</label>
                  <b-form-select id="type"
                    v-model="filters.type"
                    :plain="true"
                    :options="typeDDL">
                  </b-form-select>
              </b-form-group>
            </b-col>
            -->
         
            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
        
<!--
          <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
-->
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-clicked="rowClicked"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.summary }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.content && row.item.content.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col>{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(name)="data">
                    <span v-if="data.item.company">{{ data.item.company.alias }} - {{ data.item.company.name }}</span>
                    <span v-if="data.item.user">{{ data.item.user.name }}</span>
                </template>

                <template v-slot:cell(balance)="data">
                    {{ !isNaN(data.item.balance) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.balance) : '' }}
                </template>

              
                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(action)="data">
                  <b-button size="sm" variant="primary" @click="addBalance(data.item)" class="mr-1 btn-brand"><i class="fa fa-money" alt="Incluir saldo" title="Incluir saldo"></i></b-button>
                </template>

            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
     <b-modal 
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Conta"
            size="xl">
        <account-component :accountId="selectedItem.id"></account-component>
     </b-modal>
  
     <b-modal
              v-model="initialBalanceModal"
              id="initial-balance-modal"
              centered
              hide-footer
              title="Saldo Inicial"
              size="lg">
  
          <account-initial-balance-component :item="selectedItem" :companyId="filters.companyId" @resp="handleResp"></account-initial-balance-component>
        
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import AccountInitialBalanceComponent from './AccountInitialBalanceComponent.vue'
  import AccountComponent from './AccountComponent.vue';

  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      AccountComponent,
      AccountInitialBalanceComponent
    },
    data: () => {
      return {
        editModal: false,
        companyDDL: [],
        typeDDL: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Empresa',
            value: '1'
          },
          {
            text: 'Pessoal',
            value: '2'
          }
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        companyDDL: [],
        
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        initialBalanceModal: false,
        filters: {
          type: 1,
          companyId: null,
          key: '',
          status: 0
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'single',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          {key: 'name', label: 'Conta', sortable: true },
          //{key: 'balance', label: 'Saldo', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          {key: 'balance', label: 'Saldo', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
          //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } },
          {key: 'action', label: '', sortable: false, thStyle: { width: "40px" }, tdClass: 'align-middle' },
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  (item.company && (this.$utils.filterString(item.company.name, this.filters.key) || this.$utils.filterString(item.company.alias, this.filters.key)))
                  || (item.user && (this.$utils.filterString(item.user.name, this.filters.key) || this.$utils.filterString(item.user.alias, this.filters.key)))
                  //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )                  
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     

      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },

      async saveItem(currentItem) {

        var s = this;
        var postData = {...currentItem};

        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id,
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/franchise/group",
            postData
        ).then(function() {
            s.closeInitialBalanceModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);

            toast ({
                type: VueNotifications.types.warn,
                title: 'Grupo',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });

    },

    save() {

        let msgError = [];

        if(this.selectedItem.name.length <= 2)
            msgError.push("Sigla");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Grupo',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },

      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeInitialBalanceModal() {
        this.initialBalanceModal = false;
      },
      rowClicked(item) {
        this.selectedItem = item
        this.editModal = true
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },

      addBalance(item) {
        this.selectedItem = item
        this.initialBalanceModal = true
      },

      async refreshData() {
        try {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            this.isBusy = true;

            await axios.get(
              this.$store.state.ws_url + "/account?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.items = resp.data.obj;
            }
            ).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Contas',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })
            });

            this.isBusy = false;
        } catch (e) {
            console.log(e)
        }
      },
      changeCompany() {
        this.refreshData()
      },
      handleResp(resp) {
        this.initialBalanceModal = false
        this.refreshData()        
      },
      openHelp(url) {
        window.open(this.$store.state.config.ws_help + url, '_blank')
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      this.changeCompany()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>